const CountDown = () =>
  import(/* webpackChunkName: "count-down" */ "@/components/CountDown/index");

const Mobile = () =>
  import(
    /* webpackChunkName: "mobile" */ "@/components/AccountPage/Personal/PersonalContact/Mobile"
  );

const Phone = () =>
  import(
    /* webpackChunkName: "phone" */ "@/components/AccountPage/Personal/PersonalContact/Phone"
  );

const Email = () =>
  import(
    /* webpackChunkName: "email" */ "@/components/AccountPage/Personal/PersonalContact/Email"
  );

export default {
  name: "personal-contact",
  components: { CountDown, Mobile, Phone, Email }
};
